export default [
  {
    path: "/notifications/",
    name: "notifications",
    component: () => import("@/features/notifications/pages/NotificationsPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "app",
      group: "Notifications",
      title: "Notifications",
      breadcrumbs: [{ name: "Notifications", route: "notifications" }],
    },
  },
];